import { FC } from 'react';

import { Button, Heading, Paragraph } from '@purpur/library';
import { Icon } from '@purpur/library/icon';
import { time } from '@purpur/library/icon/assets/time';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';
import { LeadModal } from '@telialt/common-lead/src';
import { LeadsApplicationFormType } from '@telialt/common-lead/src/model';

import { PLANS_TEST_IDS } from '../../../../test-ids';
import { usePlanOrderLeadModalControls } from '../../../PlanCard/public-components/PlanOrdering/PlanOrderLeadModal/usePlanOrderLeadModalControls';
import { NoNboOffersWrapper } from './NoNboOffers.styles';

export const NoNboOffers: FC = () => {
    const { t } = useTranslations();

    const { isPlanOrderLeadModalOpen, closePlanOrderLeadModal, openPlanOrderLeadModal } =
        usePlanOrderLeadModalControls();

    return (
        <>
            <NoNboOffersWrapper>
                <Icon svg={time} size="xl" aria-hidden={true} />
                <Heading tag="h2" variant="title-200">
                    {t['plans.plans_list.no_nbo_offers.heading']}
                </Heading>
                <Paragraph>{t['plans.plans_list.no_nbo_offers.text']}</Paragraph>
                <Button
                    variant="primary"
                    data-test={PLANS_TEST_IDS.GET_OFFER_BUTTON}
                    onClick={() => openPlanOrderLeadModal()}
                >
                    {t['plans.plans_list.no_nbo_offers.get_offer.button']}
                </Button>
            </NoNboOffersWrapper>
            <LeadModal
                isOpen={isPlanOrderLeadModalOpen}
                leadsType={LeadsApplicationFormType.PlanChange}
                onClose={closePlanOrderLeadModal}
            />
        </>
    );
};
